import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import getBaseLen from "../../helpers/getBaseLen";

function BasesOverlay({ overlayData }) {
  const { r1, r2, dist } = overlayData;
  const txt = getBaseLen(dist);

  return (
    <div className="tw-h-6 tw-border-t border-1 tw-relative">
      <div className="tw-absolute tw-inset-0 bg-2 tw-opacity-40" />
      <div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-opacity-70 color-3">
        <div style={{ width: r1 }} />
        <div
          style={{ width: `${r2 - r1}px` }}
          className="tw-flex tw-items-center tw-justify-center"
        >
          <div className="tw--mr-1 tw-mt-px">
            <FontAwesomeIcon icon={faAngleLeft} />
          </div>
          <div className="tw-border-t border-contrast tw-flex-grow tw-mr-2" />
          <div className="tw-flex-shrink-0 tw-w-20 tw-text-center">{txt}</div>
          <div className="tw-border-t border-contrast tw-flex-grow tw-mr-2" />
          <div className="tw--ml-2 tw-mt-px">
            <FontAwesomeIcon icon={faAngleRight} />
          </div>
        </div>
        <div className="tw-flex-grow" />
      </div>
    </div>
  );
}

BasesOverlay.propTypes = {
  overlayData: PropTypes.shape({
    r1: PropTypes.number.isRequired,
    r2: PropTypes.number.isRequired,
    dist: PropTypes.number.isRequired,
  }).isRequired,
};

export default React.memo(BasesOverlay);
